import { render, staticRenderFns } from "./MsgPlatSetting.vue?vue&type=template&id=64df5fa7&"
import script from "./MsgPlatSetting.vue?vue&type=script&lang=js&"
export * from "./MsgPlatSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports